import { PolicyCodes } from '@joinfluffy/common';

import { useInsuranceDataContext } from '~/hooks/insurance-data-provider/useInsuranceDataContext';

export function useSelectedPolicyPriceForAllPets(selectedPolicyCode: PolicyCodes) {
  const context = useInsuranceDataContext();

  return context.policyPriceForAllPets?.[selectedPolicyCode];
}
